import React, { useState, useEffect } from 'react'
import injectSheet from 'react-jss'
import Container from '../../../../container/container'
import Description from '../../../../description/description'
import Wrapper from '../../../../wrapper/wrapper'
import duck from '../../../../images/su-duck.gif'
import FormWrapper from '../../../../form-wrapper/form-wrapper'
import FormHolder from '../../../../form-holder/form-holder'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormCheckbox from 'pobble-components/dist/form-elements/form-checkbox'
import FormRow from '../../../../form-row/form-row'
import FormLabel from '../../../../form-label/form-label'
import Footer from '../../../../footer/footer'
import { Formik } from 'formik'
import Button from 'pobble-components/dist/button'
import * as Yup from 'yup'
import { validateDisplayName } from 'pobble-components/dist/validators'
import { useMe } from 'pobble-components/dist/pobble-user'
import {
  apiSendAccountDetails,
  apiSetRoleInLife
} from '../../../../../common/api/profile'
import { useOrigin } from '../../../../../common/utils'
import { errorHandler } from 'pobble-components/dist/error-handler'

const Form = injectSheet({
  checkboxHolder: {
    margin: '40px 0 0',
    '& label': {
      margin: '0 0 0 9px'
    }
  }
})(({ classes, options }) => {
  const { refetchMe } = useMe()
  const [pending, setPending] = useState(false)
  const origin = useOrigin()

  useEffect(
    () => {
      if (origin === 'parent') {
        apiSetRoleInLife({ role_in_life: 'parent' })
          .then(refetchMe)
          .catch(errorHandler)
      }
    },
    [origin]
  )

  return (
    <Formik
      onSubmit={values => {
        setPending(true)
        apiSendAccountDetails({
          signup_account_type_decision: 'teacher',
          first_name: values.firstName,
          last_name: values.lastName,
          display_name: values.displayName,
          toc_accept: values.tc
        })
          .then(refetchMe)
          .catch(e => {
            setPending(false)
            errorHandler(e)
          })
      }}
      isInitialValid={formik =>
        formik.validationSchema.isValidSync(formik.initialValues)
      }
      initialValues={{
        firstName: options.first_name || '',
        lastName: options.last_name || '',
        displayName: options.display_name || '',
        news: options.newsletter || true,
        tc: options.toc_accepted || false
      }}
      validationSchema={Yup.object().shape({
        firstName: Yup.string().required('Please provide your first name'),
        lastName: Yup.string().required('Please provide your last name'),
        displayName: validateDisplayName().required(
          'Please provide your display name'
        ),
        tc: Yup.boolean().oneOf([true], 'Please accept tearms and conditions')
      })}>
      {props => {
        const {
          handleSubmit,
          values,
          handleChange,
          handleBlur,
          touched,
          errors,
          isValid
        } = props
        return (
          <FormWrapper pending={pending}>
            <form onSubmit={handleSubmit}>
              <FormHolder>
                <FormRow>
                  <FormLabel htmlFor="firstName">First name</FormLabel>
                  <FormInput
                    center
                    validationError={touched.firstName && errors.firstName}
                    id="firstName"
                    name="firstName"
                    placeholder="William"
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </FormRow>
                <FormRow>
                  <FormLabel htmlFor="lastName">Last name</FormLabel>
                  <FormInput
                    center
                    validationError={touched.lastName && errors.lastName}
                    id="lastName"
                    name="lastName"
                    placeholder="Shakespeare"
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </FormRow>
                <FormRow>
                  <FormLabel htmlFor="displayName">Display name</FormLabel>
                  <FormInput
                    center
                    validationError={touched.displayName && errors.displayName}
                    id="displayName"
                    name="displayName"
                    placeholder="Bard of Avon"
                    value={values.displayName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </FormRow>
                <div className={classes.checkboxHolder}>
                  <FormRow small left inline>
                    <FormCheckbox
                      id="tc"
                      name="tc"
                      checked={values.tc}
                      onChange={handleChange}
                    />
                    <FormLabel htmlFor="tc">I agree to the</FormLabel>
                    &nbsp;
                    <a
                      className={classes.link}
                      href="https://www.pobble.com/terms-of-service"
                      target="_bank">
                      terms
                    </a>
                    &nbsp;and&nbsp;
                    <a
                      href="https://www.pobble.com/privacy-policy"
                      target="_bank"
                      className={classes.link}>
                      privacy policy
                    </a>
                  </FormRow>
                </div>
              </FormHolder>
              <Footer dense>
                <Button
                  tall
                  darkBlue
                  disabled={!isValid}
                  wide
                  type="submit"
                  className={'metrics__next-step-chosen'}>
                  Next
                </Button>
              </Footer>
            </form>
          </FormWrapper>
        )
      }}
    </Formik>
  )
})

const UserAccountDetails = ({ options, forcedAccount }) => {
  return (
    <Wrapper>
      <Container primary img={duck}>
        <Description smallFont title="Complete your account" />
        <Form options={options} />
      </Container>
    </Wrapper>
  )
}

export default UserAccountDetails
